import React, { useState } from "react";
import { KeyRound, Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { authClient, useAuth } from "../../lib/AuthContext";

export const AdminChangePassword = () => {
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [cur, setCur] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const mustChange = user?.must_change_password;

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Password must be at least 8 characters");
    if (pw !== pw2) return toast.error("Passwords don't match");
    setBusy(true);
    try {
      await authClient.post("/auth/change-password", {
        current_password: mustChange ? "" : cur,
        new_password: pw,
      });
      await refresh();
      toast.success("Password updated");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not change password");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-lg" data-testid="change-password-page">
      <h1 className="font-display font-black uppercase text-2xl sm:text-3xl text-[#111619]">
        {mustChange ? "Set your password" : "Change password"}
      </h1>
      {mustChange && (
        <div className="mt-3 rounded-md border border-[#f28a16]/40 bg-[#fff7ed] px-4 py-3 text-sm text-[#7c2d12]" data-testid="must-change-banner">
          <ShieldCheck size={14} className="inline mr-1 text-[#f28a16]" />
          Your account was created with a temporary password. Please set a new one now — this replaces the temporary credentials the recovery migration issued.
        </div>
      )}
      <form onSubmit={submit} className="mt-5 space-y-3 bg-white border border-[#cfd7db] rounded-md p-5">
        {!mustChange && (
          <label className="block">
            <span className="text-xs font-display uppercase tracking-widest text-[#3f4b52] block mb-1">Current password</span>
            <input type="password" required value={cur} onChange={(e) => setCur(e.target.value)}
              className="w-full h-11 px-3 border border-[#cfd7db] rounded-md" data-testid="pw-current" />
          </label>
        )}
        <label className="block">
          <span className="text-xs font-display uppercase tracking-widest text-[#3f4b52] block mb-1">New password (8+)</span>
          <input type="password" required minLength={8} autoFocus value={pw} onChange={(e) => setPw(e.target.value)}
            className="w-full h-11 px-3 border border-[#cfd7db] rounded-md" data-testid="pw-new" />
        </label>
        <label className="block">
          <span className="text-xs font-display uppercase tracking-widest text-[#3f4b52] block mb-1">Confirm new password</span>
          <input type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)}
            className="w-full h-11 px-3 border border-[#cfd7db] rounded-md" data-testid="pw-new2" />
        </label>
        <button type="submit" disabled={busy} data-testid="pw-save"
          className="w-full bg-[#f28a16] text-white rounded-md py-3 font-display uppercase tracking-widest text-sm inline-flex items-center justify-center gap-2 disabled:opacity-60">
          {busy ? <Loader2 className="animate-spin" size={16} /> : <KeyRound size={16} />}
          {mustChange ? "Set password & continue" : "Save new password"}
        </button>
      </form>
    </div>
  );
};

export default AdminChangePassword;
